module.exports = __webpack_public_path__ + "static/flags/LH-39fadaf711ddea75ae7fa061440b81a2.gif";